import { render, staticRenderFns } from "./LogoNav.vue?vue&type=template&id=65c3444d&scoped=true"
import script from "./LogoNav.vue?vue&type=script&lang=js"
export * from "./LogoNav.vue?vue&type=script&lang=js"
import style0 from "./LogoNav.vue?vue&type=style&index=0&id=65c3444d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65c3444d",
  null
  
)

export default component.exports